import React from 'react';

interface SigningErrorProps {
  type: 'expired' | 'not_found' | 'network';
  onRetry?: () => void;
}

const ERROR_MESSAGES: Record<string, { title: string; message: string }> = {
  expired: {
    title: 'Link Expired',
    message:
      'This link is no longer valid. Please go back to the app and try again.',
  },
  not_found: {
    title: 'Not Found',
    message: 'This document is no longer available.',
  },
  network: {
    title: 'Connection Error',
    message: 'Could not load documents. Check your connection and try again.',
  },
};

const SigningError: React.FC<SigningErrorProps> = ({ type, onRetry }) => {
  const { title, message } = ERROR_MESSAGES[type] || ERROR_MESSAGES.network;

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.warningCircle}>
          <span style={styles.exclamation}>!</span>
        </div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>
      </div>

      {type === 'network' && onRetry && (
        <div style={styles.bottomArea}>
          <button type="button" style={styles.retryButton} onClick={onRetry}>
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#f9fafb',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
  },
  warningCircle: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: '#fef3c7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
  },
  exclamation: {
    fontSize: 40,
    fontWeight: 700,
    color: '#d97706',
    lineHeight: 1,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#111827',
    margin: '0 0 8px 0',
    textAlign: 'center',
  },
  message: {
    fontSize: 16,
    color: '#6b7280',
    margin: 0,
    textAlign: 'center',
    lineHeight: '1.5',
  },
  bottomArea: {
    padding: '16px 20px',
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
  },
  retryButton: {
    width: '100%',
    height: 52,
    borderRadius: 12,
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontSize: 17,
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
  },
};

export default SigningError;
